<script setup lang="ts">
import { getArticleDetail } from "@carnet/api/backoffice";

const nuxtApp = useNuxtApp();
const { data: article } = await useAsyncData(
  "article-federation-about",
  async () => {
    const response = await getArticleDetail({ composable: "$fetch", path: { locale: appLocale(), code: "federationAbout" } });
    return response?.data ?? null;
  },
  { getCachedData: (key) => nuxtApp.payload.data[key] ?? nuxtApp.static.data[key] }
);
</script>

<template>
  <AppSection v-if="article" :ui="{ base: 'sm:py-10' }">
    <div class="relative overflow-hidden bg-inverted text-inverted sm:rounded-2xl max-sm:-mx-4 md:min-h-133 flex flex-col">
      <WebArticlePicture
        :main-image="article.mainImage?.url"
        alt="FFESSM"
        picture-class="absolute inset-0 size-full object-cover"
        img-class="absolute inset-0 size-full object-cover"
      />
      <div class="absolute inset-0 bg-linear-to-b from-lagoon-300/30 to-blue-800/30 mix-blend-hue" />
      <div class="absolute inset-0 bg-blue-800/40" />

      <div class="relative grow px-4 py-16 sm:p-12 flex flex-col gap-y-6">
        <div class="mb-auto px-4">
          <UIcon name="icon:logo-ffessm" aria-label="FFESSM" role="img" class="h-16.5 w-auto" />
        </div>
        <h2 class="text-3xl sm:text-4xl font-semibold leading-tight mb-5 max-w-114">
          {{ article.title }}
        </h2>
        <p class="text-base leading-snug max-w-xl">
          {{ article.content }}
        </p>
      </div>
    </div>
  </AppSection>
</template>
